export const minimumInputNumber = 0
export const maximumInputNumber = 999999999999999
